import Flickity from "flickity";

var $html;
var $window;

var lastViewportY;

$(function () {
  /* fixes, helpers, and setup */

  // globals
  $html = $("html");
  $window = $(window);

  lastViewportY = $window.scrollTop();

  // fixes double touch issue on iOS devices
  if (
    navigator.userAgent.indexOf("iPad") !== -1 ||
    navigator.userAgent.indexOf("iPhone") !== -1
  ) {
    $("a:not([href ^= '#']):not([data-fancybox]):not(.js-scroll-link)").on(
      "click",
      function (event) {
        if ($(this).attr("target") == "_blank") {
          window.open($(this).attr("href"), "_blank");
          event.preventDefault();
        } else window.location = $(this).attr("href");
      }
    );
  }

  $("a[href ^= '#']:not([data-fancybox])").click((event) => {
    event.preventDefault();

    var id = $(event.currentTarget).attr("href");
    var scrollOffset =
      Number($(id).offset().top) - Number($(".header").height());

    $("body, html").animate(
      {
        scrollTop: scrollOffset,
      },
      500
    );
  });

  // inlines table headers on first mobile view
  if ($(".rich-text table").length) {
    if ($window.width() < 1024) inlineHeaders();
    else $window.resize(inlineHeaders);
  }

  // carousel early, to avoid issues
  // Flickity's jQuery-bridge build fakes its own require() calls in a way
  // Rollup can't resolve, so this uses the plain Flickity constructor
  // instead of the $.fn.flickity() jQuery-plugin syntax -- same options and
  // output.
  var heroCarouselEl = document.querySelector(".hero__carousel");
  if (heroCarouselEl) {
    var heroCarousel = new Flickity(heroCarouselEl, {
      draggable: false,
      wrapAround: true,
      autoPlay: 6000,
      pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      pageDots: true,
    });
    heroCarousel.resize();
  }

  $("select").selectric({
    arrowButtonMarkup:
      '<svg class="selectric__icon    icon"><use xlink:href="#icon-chevron-down"></use></svg>',
    maxHeight: 512,
    onBeforeOpen: selectric_before_open,
    onBeforeClose: selectric_before_close,
  });

  $("select.removeSelectric").selectric("destroy"); // Destroy select and go back to normal

  // because selectric is dumb
  $(".selectric-wrapper").each(function () {
    var duration = $(this).find(".selectric-scroll li").length * 0.1 + "s";

    $(this).find(".selectric-items").css("transition-duration", duration);
  });

  // reallllly dumb
  $(".selectric-scroll li").hover(function () {
    $(this).closest(".selectric-scroll").find("li").removeClass("highlighted");
    $(this).addClass("highlighted");
  }, null);

  // suuuuper dumb
  $(".selectric-wrapper .label").click(function (event) {
    var $selectric = $(this).parents(".selectric-wrapper").first();

    if ($selectric.hasClass("selectric-open")) {
      $selectric
        .find(".selectric-hide-select select")
        .data("selectric")
        .close();
      event.stopPropagation();
      event.preventDefault();
    }
  });

  // mmenu
  if ($("#mobile-menu").length) {
    $("#mobile-menu").mmenu({
      navbar: { title: "Menu" },
      setSelected: { current: "detect" },
      offCanvas: {
        position: "right",
        zposition: "next",
      },
      onClick: { close: false },
      extensions: ["fx-panels-slide-0"],
    });

    var mmenu = $("#mobile-menu").data("mmenu");

    mmenu.bind("open:start", function () {
      $(".header").css("top", $(window).scrollTop() - $(".header").height());
    });

    mmenu.bind("close:start", function () {
      $html.removeClass("menu--open");
    });

    mmenu.bind("close:finish", function () {
      $(".header").css("top", "");
    });
  }

  // aos
  AOS.init({
    disable: function () {
      return $(window).width() < 1024;
    },
    duration: 1000,
    offset: 0,
    once: true,
  });

  if ($(".menu").length) {
    // used for menu animation
    resizeMenu();
    $window.resize(resizeMenu);
  }

  // calendar view - force list at mobile, but return to current on resize
  if ($(".calendar").length) {
    responsiveCalendar();
    $window.resize(responsiveCalendar);

    $(".filter__control--view input[type=radio]").change(function () {
      if (this.getAttribute("value") == "grid") {
        $(".calendar").removeClass("calendar--list");
        $(".calendar").addClass("calendar--grid");
      } else if (this.getAttribute("value") == "list") {
        $(".calendar").removeClass("calendar--grid");
        $(".calendar").addClass("calendar--list");
      }
    });
  }

  /* State classes - toggle classes on html element for page-wide state (menu open, overlay, etc) */

  // scroll--top: viewport is scrolled to the top of the page
  // scroll--up: viewport last scrolled up
  setScrollState();
  $window.scroll(setScrollState);

  // menu--open: allows 'many to many' buttons opening site menu
  $(".header__burger").click(function () {
    $html.toggleClass("menu--open");

    if ($window.width() < 1024) $("#mobile-menu").data("mmenu").open();
  });

  // search--open: search bar is open
  $(".header__button--search").click(function () {
    if ($html.hasClass("search--open")) $(".search__input").focus();

    // only open the search bar if it's attached to the header
    // (ie not the search page, where it's fixed)
    if ($(".search.search--header")) $html.toggleClass("search--open");
  });

  // Accordion
  $(".accordion").each(function () {
    $(this).accordion({
      transitionSpeed: 600,
      transitionEasing: "ease-out",
    });
  });

  $(".accordion").on("accordion.open", function (event) {
    event.stopPropagation();

    var $this = $(this);

    $this.children(".sub-nav__button").html("-");

    $this.children("[data-control]").attr("aria-expanded", "true");
    $this.children("[data-content]").attr("aria-hidden", "false");
  });

  $(".accordion").on("accordion.close", function (event) {
    event.stopPropagation();

    var $this = $(this);

    $this.children(".sub-nav__button").html("+");

    $this.children("[data-control]").attr("aria-expanded", "false");
    $this.children("[data-content]").attr("aria-hidden", "true");
  });

  // transition schools block on home page with accordion
  if ($(".schools").length) {
    $(".schools [data-control]").click(function () {
      $(".schools__image")
        .removeClass("schools__image--visible")
        .eq($(this).parent().index())
        .addClass("schools__image--visible");
    });
  }

  $(".filter__control select").on("selectric-change", function () {
    $(this).closest("form").submit();
  });

  var cm_form = $(".quick-links__form");
  if (cm_form.length) {
    cm_form.submit(function (event) {
      event.preventDefault();

      $.ajax({
        url: window.location.href,
        method: "post",
        data: cm_form.serialize(),
        success: function (data) {
          alert("Thank you for subscribing to our newsletter!");
        },
        error: function (data) {
          alert("An error occured, please try again later.");
        },
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const alert_elem = document.querySelector(".alert-banner");

  if (alert_elem) {
    document.querySelector(".header").classList.add("header--alert");
    document.querySelector(".page").classList.add("page--alert");

    document
      .querySelector(".alert-banner__close")
      .addEventListener("click", () => {
        Cookie.set("alert_closed", alert_elem.dataset.id, {
          expires: "1Y",
          secure: true,
        });

        document.querySelector(".header").classList.remove("header--alert");
        document.querySelector(".page").classList.remove("page--alert");
        document.querySelector(".alert-banner").remove();
      });
  }
});

// needs to happen after all images loaded to avoid isssues with the page resizing after the scroll
window.addEventListener("load", function () {
  if (window.location.hash.length > 0) {
    $("html").animate(
      {
        scrollTop:
          $(window.location.hash).offset().top - $(".header").height() - 64,
      },
      500
    );

    setTimeout(function () {
      $("html").removeClass("scroll--up");
    }, 550);
  }
});

// not using event params, as they're undefined
function selectric_before_open() {
  var $selectric = $(this).parents(".selectric-wrapper").first();
  var height = $selectric.find(".selectric-scroll")[0].scrollHeight + "px";

  $selectric.find(".selectric-items").css("height", height);
}

function selectric_before_close() {
  var $selectric = $(this).parents(".selectric-wrapper").first();

  $selectric.find(".selectric-items").css("height", "");
}

// inlines table headers at mobile (designed for redactor)
function inlineHeaders() {
  if ($window.width() < 1024) {
    $window.off("resize", inlineHeaders);

    $(".rich-text table").each(function () {
      var $headers = $(this).find("thead th");

      if ($headers.length == 0) return;

      $(this)
        .find("tbody tr")
        .each(function () {
          $(this)
            .find("td")
            .each(function (i) {
              $(this).prepend(
                '<span class="column-title">' +
                  $headers.eq(i).html() +
                  ": </span>"
              );
            });
        });
    });
  }
}

function setScrollState() {
  if ($window.scrollTop() < 1.5 * rem()) $html.addClass("scroll--top");
  else if ($window.scrollTop() > parseInt($(".page").css("padding-top")))
    $html.removeClass("scroll--top");

  if (
    $html.hasClass("menu--open") ||
    $html.hasClass("search--open") ||
    $window.scrollTop() < lastViewportY
  )
    $html.addClass("scroll--up");
  else $html.removeClass("scroll--up");
  lastViewportY = $window.scrollTop();

  if ($window.scrollTop() < $window.height())
    $html.addClass("scroll--first-page");
  else $html.removeClass("scroll--first-page");
}

// gets current rem size in px
function rem() {
  return parseInt($html.css("font-size").slice(0, -2));
}

function resizeMenu() {
  $(".menu").css("height", $(".menu__container")[0].scrollHeight);
}

var calendarMod = null;
var $calendar = $(".calendar");
function responsiveCalendar() {
  if (calendarMod === null && $window.width() < 1024) {
    if ($calendar.hasClass("calendar--list")) calendarMod = "list";
    else {
      calendarMod = "grid";
      $calendar.removeClass("calendar--grid");
      $calendar.addClass("calendar--list");
    }
  } else if (calendarMod !== null && $window.width() >= 1024) {
    if (calendarMod == "grid") {
      $calendar.removeClass("calendar--list");
      $calendar.addClass("calendar--grid");
    }

    calendarMod = null;
  }
}

// Exposed on window because it's invoked as a callback param from the
// external Google Maps API script tag (templates/_blocks/map.twig), outside
// any module scope -- ES modules are scoped by default, not global.
window.initMaps = initMaps;

function initMaps() {
  var $mapList = $(".google-map");

  for (var mapElement of $mapList) {
    var $content = $(mapElement).find(".google-map__content");
    var infoContent = "";

    if ($content.length) {
      infoContent = $content[0].outerHTML;
      $content.remove();
    }

    var coords = null;

    if (
      mapElement.dataset.latitude !== undefined &&
      mapElement.dataset.longitude !== undefined
    ) {
      var coords = {
        lat: parseFloat(mapElement.dataset.latitude),
        lng: parseFloat(mapElement.dataset.longitude),
      };
    } else {
      console.log("Error initializing map: no geocoding found");
      continue;
    }

    var googleMap = new google.maps.Map(mapElement, {
      center: coords,
      zoom: 16,
      styles: map_styles,
      disableDefaultUI: true,
    });

    if (infoContent.length) {
      new google.maps.InfoWindow({
        content: infoContent,
        position: coords,
      }).open(googleMap);
    }
  }
}

var map_styles = [
  {
    stylers: [
      {
        hue: "#007fff",
      },
      {
        saturation: 89,
      },
    ],
  },
  {
    featureType: "water",
    stylers: [
      {
        color: "#ffffff",
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "labels",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
];
